import Api from "../../api/index";

const Championship = {
  namespaced: true,
  state: {
    oneChampionship: null,
    allChampionships: null,

    oneMatch: null,

    allEvents: null,

    allStats: null,

    createWasGood: null,
    createMessage: null,
    createdID: null,

    createTeamWasGood: null,
    createTeamMessage: null,
    updateTeamWasGood: null,
    updateTeamMessage: null,

    createSquadWasGood: null,
    createSquadMessage: null,
    updateSquadWasGood: null,
    updateSquadMessage: null,

    createRoundWasGood: null,
    createRoundMessage: null,
    updateRoundWasGood: null,
    updateRoundMessage: null,

    createMatchWasGood: null,
    createMatchMessage: null,
    updateMatchWasGood: null,
    updateMatchMessage: null,
  },
  getters: {
    hasWinners(state, getters) {
      if (state.oneChampionship) {
        if (Object.keys(getters.winners).length > 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    winners: (state) => {
      // Já ordenado por colocação
      if (state.oneChampionship) {
        return {
          ...state.oneChampionship.data.attributes.edition.data
            .map((o) => o.attributes.winners)
            .map((o) => o.data)[0]
            .map((o) => o.attributes),
        };
      } else {
        return null;
      }
    },
  },
  mutations: {
    getOneChampionship(state, oneChamp) {
      state.oneChampionship = oneChamp;
    },
    getAllChampionships(state, allChamps) {
      state.allChampionships = allChamps.data;
    },
    createGood(state, { was_good, msg, id }) {
      state.createWasGood = was_good;
      state.createMessage = msg;
      state.createdID = id;
      setTimeout(() => {
        state.createWasGood = null;
      }, 200);
    },

    // CHAMP TEAM
    createTeamGood(state, { was_good, msg }) {
      state.createTeamWasGood = was_good;
      state.createTeamMessage = msg;
      setTimeout(() => {
        state.createTeamWasGood = null;
      }, 200);
    },
    updateTeamGood(state, { was_good, msg }) {
      state.updateTeamWasGood = was_good;
      state.updateTeamMessage = msg;
      setTimeout(() => {
        state.updateTeamWasGood = null;
      }, 200);
    },

    // SQUADS
    createSquadGood(state, { was_good, msg }) {
      state.createSquadWasGood = was_good;
      state.createSquadMessage = msg;
      setTimeout(() => {
        state.createSquadWasGood = null;
      }, 200);
    },
    updateSquadGood(state, { was_good, msg }) {
      state.updateSquadWasGood = was_good;
      state.updateSquadMessage = msg;
      setTimeout(() => {
        state.updateSquadWasGood = null;
      }, 200);
    },

    // ROUNDS
    createRoundGood(state, { was_good, msg }) {
      state.createRoundWasGood = was_good;
      state.createRoundMessage = msg;
      setTimeout(() => {
        state.createRoundWasGood = null;
      }, 200);
    },
    updateRoundGood(state, { was_good, msg }) {
      state.updateRoundWasGood = was_good;
      state.updateRoundMessage = msg;
      setTimeout(() => {
        state.updateRoundWasGood = null;
      }, 200);
    },

    // EVENTS
    getAllEvents(state, events) {
      state.allEvents = events.data;
    },

    // MATCHES
    getOneMatch(state, match) {
      state.oneMatch = match.data;
    },
    createMatchGood(state, { was_good, msg }) {
      state.createMatchWasGood = was_good;
      state.createMatchMessage = msg;
      setTimeout(() => {
        state.createMatchWasGood = null;
      }, 200);
    },
    updateMatchGood(state, { was_good, msg }) {
      state.updateMatchWasGood = was_good;
      state.updateMatchMessage = msg;
      setTimeout(() => {
        state.updateMatchWasGood = null;
      }, 200);
    },

    // STATS
    setAllStatistics(state, stats) {
      state.allStats = stats;
    },

    clearOneChampionship(state) {
      state.oneChampionship = null;
    },
    clearOneMatch(state) {
      state.oneMatch = null;
    },
  },
  actions: {
    clearOneChampionship({ commit }) {
      commit("clearOneChampionship");
    },
    clearOneMatch({ commit }) {
      commit("clearOneMatch");
    },
    show(context, { id, filter }) {
      return Api.Championship.show(id)
        .then((response) => response.data)
        .then((oneChamp) => {
          context.commit("getOneChampionship", oneChamp);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    index(context) {
      Api.Championship.index()
        .then((response) => response.data)
        .then((champs) => {
          context.commit("getAllChampionships", champs);
        });
    },
    create(context, { newChamps }) {
      return Api.Championship.create(newChamps)
        .then((response) => response.data)
        .then((champs) => {
          context.commit("createGood", {
            was_good: true,
            msg: "success",
            id: champs.id,
          });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("createGood", { was_good: false, msg: "error" });
        });
    },

    //CHAMP TEAM
    createChampTeam(context, { newChampTeam }) {
      Api.Championship.createChampTeam(newChampTeam)
        .then((response) => response.data)
        .then((team) => {
          context.commit("createTeamGood", { was_good: true, msg: "success" });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("createTeamGood", { was_good: false, msg: "error" });
        });
    },
    updateChampTeam(context, { champTeam }) {
      // console.log({ champTeam });
      return Api.Championship.updateChampTeam(champTeam)
        .then((response) => response.data)
        .then((team) => {
          console.log({ team });
          context.commit("updateTeamGood", { was_good: true, msg: "success" });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("updateTeamGood", { was_good: false, msg: "error" });
        });
    },

    //SQUADS
    createSquad(context, { newSquad }) {
      Api.Championship.createSquad(newSquad)
        .then((response) => response.data)
        .then((team) => {
          context.commit("createSquadGood", {
            was_good: true,
            msg: "success",
          });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("createSquadGood", {
            was_good: false,
            msg: "error",
          });
        });
    },
    updateSquad(context, { squad }) {
      Api.Championship.updateSquad(squad)
        .then((response) => response.data)
        .then((team) => {
          context.commit("updateSquadGood", { was_good: true, msg: "success" });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("updateSquadGood", { was_good: false, msg: "error" });
        });
    },

    //ROUNDS
    createRound(context, { newRound }) {
      return Api.Championship.createRound(newRound)
        .then((response) => response.data)
        .then((team) => {
          console.log({ newRound });
          context.commit("createRoundGood", { was_good: true, msg: "success" });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("createRoundGood", { was_good: false, msg: "error" });
        });
    },
    updateRound(context, { squad }) {
      Api.Championship.updateRound(squad)
        .then((response) => response.data)
        .then((team) => {
          console.log({ team });
          context.commit("updateRoundGood", { was_good: true, msg: "success" });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("updateRoundGood", { was_good: false, msg: "error" });
        });
    },

    //EVENTS
    indexEvent(context) {
      Api.Championship.indexEvent()
        .then((response) => response.data)
        .then((events) => {
          // console.log({Event});
          context.commit("getAllEvents", events);
        })
        .catch((error) => {
          console.log({ indexEventError: error });
          // context.commit('createMatchGood', {was_good: false, msg: 'error'})
        });
    },

    //MATCHES
    showMatch(context, { match_id }) {
      return Api.Championship.showMatch(match_id)
        .then((response) => response.data)
        .then((match) => {
          // console.log({match});
          context.commit("getOneMatch", match);
        })
        .catch((error) => {
          console.log({ showMatchError: error });
          // context.commit('createMatchGood', {was_good: false, msg: 'error'})
        });
    },
    createMatch(context, { newMatch }) {
      Api.Championship.createMatch(newMatch)
        .then((response) => response.data)
        .then((team) => {
          console.log({ team });
          context.commit("createMatchGood", { was_good: true, msg: "success" });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("createMatchGood", { was_good: false, msg: "error" });
        });
    },
    updateMatch(context, { match }) {
      // console.log({match});
      Api.Championship.updateMatch(match)
        .then((response) => response.data)
        .then((team) => {
          console.log({ team });
          context.commit("getOneMatch", team);
          context.commit("updateMatchGood", { was_good: true, msg: "success" });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("updateMatchGood", { was_good: false, msg: "error" });
        });
    },
    updateMatchDetails(context, { match }) {
      // console.log({match});
      return Api.Championship.updateMatchDetails(match)
        .then((response) => response.data)
        .then((team) => {
          // console.log({ team });
          context.commit("getOneMatch", team);
          context.commit("updateMatchGood", { was_good: true, msg: "success" });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("updateMatchGood", { was_good: false, msg: "error" });
        });
    },
    updateMatchTime(context, { match }) {
      // console.log({match});
      Api.Championship.updateMatchTime(match)
        .then((response) => response.data)
        .then((team) => {
          console.log({ team });
          context.commit("getOneMatch", team);
          context.commit("updateMatchGood", { was_good: true, msg: "success" });
        })
        .catch((error) => {
          console.log({ error });
          context.commit("updateMatchGood", { was_good: false, msg: "error" });
        });
    },

    // STATISTICS
    indexStatistics(context, { params }) {
      Api.Championship.indexStatistics(params)
        .then((response) => response.data)
        .then((stat) => {
          console.log(stat.map((o) => o.games_played));
          context.commit("setAllStatistics", stat);
          // context.commit('updateMatchGood', {was_good: true, msg: 'success'})
        })
        .catch((error) => {
          console.log({ error });
          // context.commit('updateMatchGood', {was_good: false, msg: 'error'})
        });
    },
  },
};

export default Championship;
